module.exports = __webpack_public_path__ + "static/media/awardIcon.65bebea8.svg";